export default [
	/**
	 * Start
	 * EX_DEV_2622_WARMING_UP_EMOTIONAL_COURSE_UPSALES
	 */
	{
		path: 'emotional-course-fact',
		name: 'emotional-course-fact-banner',
		component: () => import(/* webpackChunkName: "onboarding" */ '../views/EmotionalCourseFactBanner.vue'),
		meta: {
			hideHeader: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingMightSoundFamiliarScreen'
				}
			}
		}
	},
	{
		path: 'emotional-course-warmup',
		name: 'emotional-course-warmup-banner',
		component: () => import(/* webpackChunkName: "onboarding" */ '../views/EmotionalCourseWarmupBanner.vue'),
		meta: {
			hideHeader: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingEmotionalCourseWarmingUpScreen'
				}
			}
		}
	},
	{
		path: 'emotional-course-offer',
		name: 'emotional-course-offer',
		component: () => import(/* webpackChunkName: "onboarding" */ '../views/EmotionalCourseOffer.vue'),
		meta: {
			hideHeader: true
		}
	}
	/**
	 * end
	 * EX_DEV_2622_WARMING_UP_EMOTIONAL_COURSE_UPSALES
	 */
]
